const getRecaptchaEnabled = () => {
  const rawValue =
    (typeof process !== "undefined"
      ? process.env.REACT_APP_RECAPTCHA_ENABLED
      : undefined) || "true";
  return rawValue.toLowerCase() !== "false";
};

const getRiskBasedCaptcha = () => {
  const rawValue =
    (typeof process !== "undefined"
      ? process.env.REACT_APP_RISK_BASED_CAPTCHA
      : undefined) || "true";
  return rawValue.toLowerCase() !== "false";
};

const DEFAULT_RECAPTCHA_ENABLED = getRecaptchaEnabled();
const DEFAULT_RISK_BASED_CAPTCHA = getRiskBasedCaptcha();

let config = {};
if (process.env.REACT_APP_ENV === "fullDevelopment") {
  config = {
    BASE_URL: "http://127.0.0.1:5000/api/",
    RECAPTCHA_SITE_PUBLIC_KEY: "6LccE6YZAAAAAInGNlfPxRYIOQADG2hoh-edNXcc",
    TRELLO_KEY: "9b8ed51dce54e4ec3ea26410ffe10116",
    CLICKUP_KEY: "ZMLF12DJ7IKDIOTTH9FH08AEV593HWKV",
    SLACK_KEY: "1050391391570.2876009322519",
    JIRA_KEY: "C37EHB8wBxyZqWvjuaIxJKcRuzx1UNEo",
    FACEBOOK_CLIENT_ID: "615804762377447",
    FACEBOOK_REDIRCT_URL: "http://localhost:3000/settings/integrations",
    LINKEDIN_CLIENT_KEY: "77e7nhpcx1ldqa",
    LINKEDIN_REDIRECT_URL: "http://localhost:3000/settings/integrations",
    RECAPTCHA_ENABLED: DEFAULT_RECAPTCHA_ENABLED,
    RISK_BASED_CAPTCHA: DEFAULT_RISK_BASED_CAPTCHA,
    SONIC_WS_URL:
      process.env.REACT_APP_SONIC_WS_URL || "ws://127.0.0.1:8080/live/ws",
  };
} else if (process.env.REACT_APP_ENV === "partialDevelopment") {
  config = {
    BASE_URL: "https://demoapi.pivony.com/api/",
    RECAPTCHA_SITE_PUBLIC_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    TRELLO_KEY: "9b8ed51dce54e4ec3ea26410ffe10116",
    CLICKUP_KEY: "ZMLF12DJ7IKDIOTTH9FH08AEV593HWKV",
    MONDAY_KEY: "bcd81e275d47b926193829d37c4505e1",
    SLACK_KEY: "1050391391570.2876009322519",
    JIRA_KEY: "C37EHB8wBxyZqWvjuaIxJKcRuzx1UNEo",
    FACEBOOK_CLIENT_ID: "615804762377447",
    FACEBOOK_REDIRCT_URL: "http://localhost:3000/settings/integrations",
    LINKEDIN_CLIENT_KEY: "77e7nhpcx1ldqa",
    LINKEDIN_REDIRECT_URL: "http://localhost:3000/settings/integrations",
    RECAPTCHA_ENABLED: DEFAULT_RECAPTCHA_ENABLED,
    RISK_BASED_CAPTCHA: DEFAULT_RISK_BASED_CAPTCHA,
    SONIC_WS_URL:
      process.env.REACT_APP_SONIC_WS_URL ||
      "wss://demoapi.pivony.com/sonic/live/ws",
  };
} else if (process.env.REACT_APP_ENV === "staging") {
  config = {
    BASE_URL: "https://demoapi.pivony.com/api/",
    RECAPTCHA_SITE_PUBLIC_KEY: "6LdMCagZAAAAADFPtpXqR4UyU-Tf8DLRCugmR-Hh",
    TRELLO_KEY: "9b8ed51dce54e4ec3ea26410ffe10116",
    CLICKUP_KEY: "ZMLF12DJ7IKDIOTTH9FH08AEV593HWKV",
    SLACK_KEY: "1050391391570.2876009322519",
    JIRA_KEY: "C37EHB8wBxyZqWvjuaIxJKcRuzx1UNEo",
    FACEBOOK_CLIENT_ID: "615804762377447",
    FACEBOOK_REDIRCT_URL: "https://demo.pivony.com/settings/integrations",
    LINKEDIN_CLIENT_KEY: "77e7nhpcx1ldqa",
    LINKEDIN_REDIRECT_URL: "https://demo.pivony.com/settings/integrations",
    RECAPTCHA_ENABLED: DEFAULT_RECAPTCHA_ENABLED,
    RISK_BASED_CAPTCHA: DEFAULT_RISK_BASED_CAPTCHA,
    SONIC_WS_URL:
      process.env.REACT_APP_SONIC_WS_URL ||
      "wss://demoapi.pivony.com/sonic/live/ws",
  };
} else if (process.env.REACT_APP_ENV === "production") {
  config = {
    BASE_URL: "https://app.pivony.com/api/v1/",
    RECAPTCHA_SITE_PUBLIC_KEY: "6LdMCagZAAAAADFPtpXqR4UyU-Tf8DLRCugmR-Hh",
    TRELLO_KEY: "9b8ed51dce54e4ec3ea26410ffe10116",
    CLICKUP_KEY: "ZMLF12DJ7IKDIOTTH9FH08AEV593HWKV",
    MONDAY_KEY: "bcd81e275d47b926193829d37c4505e1",
    SLACK_KEY: "1050391391570.2876009322519",
    JIRA_KEY: "oy4HFpagOP5255jIoCQNAIAxeLCjzWA1",
    FACEBOOK_CLIENT_ID: "615804762377447",
    FACEBOOK_REDIRCT_URL: "https://app.pivony.com/settings/integrations",
    LINKEDIN_CLIENT_KEY: "77e7nhpcx1ldqa",
    LINKEDIN_REDIRECT_URL: "https://app.pivony.com/settings/integrations",
    RECAPTCHA_ENABLED: DEFAULT_RECAPTCHA_ENABLED,
    RISK_BASED_CAPTCHA: DEFAULT_RISK_BASED_CAPTCHA,
    SONIC_WS_URL:
      process.env.REACT_APP_SONIC_WS_URL ||
      "wss://app.pivony.com/sonic/live/ws",
  };
} else if (process.env.REACT_APP_ENV === "customApi") {
  config = {
    BASE_URL: process.env.REACT_APP_CUSTOM_API_URL || "",
    RECAPTCHA_SITE_PUBLIC_KEY:
      process.env.REACT_APP_RECAPTCHA_SITE_PUBLIC_KEY || "",
    TRELLO_KEY: process.env.REACT_APP_TRELLO_KEY || "",
    CLICKUP_KEY: process.env.REACT_APP_CLICKUP_KEY || "",
    MONDAY_KEY: process.env.REACT_APP_MONDAY_KEY || "",
    SLACK_KEY: process.env.REACT_APP_SLACK_KEY || "",
    JIRA_KEY: process.env.REACT_APP_JIRA_KEY || "",
    FACEBOOK_CLIENT_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID || "",
    FACEBOOK_REDIRCT_URL:
      process.env.REACT_APP_FACEBOOK_REDIRECT_URL ||
      "http://localhost:3000/settings/integrations",
    LINKEDIN_CLIENT_KEY: process.env.REACT_APP_LINKEDIN_CLIENT_KEY || "",
    LINKEDIN_REDIRECT_URL:
      process.env.REACT_APP_LINKEDIN_REDIRECT_URL ||
      "http://localhost:3000/settings/integrations",
    RECAPTCHA_ENABLED: DEFAULT_RECAPTCHA_ENABLED,
    RISK_BASED_CAPTCHA: DEFAULT_RISK_BASED_CAPTCHA,
    SONIC_WS_URL:
      process.env.REACT_APP_SONIC_WS_URL || "ws://127.0.0.1:8080/live/ws",
  };
}

config.SHOPIFY_SSO_VERIFY_URL =
  process.env.REACT_APP_SHOPIFY_SSO_VERIFY_URL ||
  "https://shopify.pivony.com/sso/verify";

// App analytics only. Never GTM-M5M9V58 / G-P3CHWFV1DJ (website property 355233422).
const WEBSITE_MEASUREMENT_IDS = new Set(["GTM-M5M9V58", "G-P3CHWFV1DJ"]);
const appAnalyticsId = (
  process.env.REACT_APP_GA4_APP_ID ||
  process.env.REACT_APP_GTM_ID ||
  process.env.VITE_GA4_APP_ID ||
  process.env.NEXT_PUBLIC_GA4_APP_ID ||
  ""
).trim();
config.GTM_ID = WEBSITE_MEASUREMENT_IDS.has(appAnalyticsId)
  ? ""
  : appAnalyticsId;

export default config;
